import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { authService } from '../../services/authService';

export const VerifyPage = () => {
    const [searchParams] = useSearchParams();
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // slack_id는 URL 파라미터로 전달됨
    const slack_id = searchParams.get('user');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            await authService.verifyCode(code.toUpperCase(), slack_id);
            navigate('/auth/success');
        } catch (error) {
            if (error.response?.status === 410) {
                setError('인증 코드가 만료되었습니다.');
            } else if (error.response?.status === 404) {
                setError('잘못된 인증 코드입니다.');
            } else {
                setError('인증 중 오류가 발생했습니다.');
            }
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <Card className="w-96">
                <CardHeader>
                    <CardTitle>인증 코드 입력</CardTitle>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <Input
                                type="text"
                                value={code}
                                onChange={(e) => setCode(e.target.value.toUpperCase())}
                                placeholder="6자리 인증 코드 입력"
                                maxLength={6}
                                className="text-center text-2xl tracking-wider"
                            />
                        </div>
                        {error && (
                            <div className="text-red-500 text-sm text-center">
                                {error}
                            </div>
                        )}
                        <Button type="submit" className="w-full">
                            확인
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
};